<template>
  <div class="basket-expiry w-100">
    <div class="container">
      <div class="row" v-if="basket.allocated">
        <div
          class="col-12 text-center"
          v-if="$root.basket_timer.expires_in > 0"
        >
          Your basket will expire in
          {{ $root.basket_timer.expires_in | expireTime }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    basket() {
      return this.$store.state.basket;
    },
  },
};
</script>